import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'
import lazyLoading from './lazyLoading'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}
const createRouter = () => new Router({
  routes: [
    {
      path: '*',
      redirect: { name: 'profile' },
    },
    {
      path: '/auth',
      component: EmptyParentComponent,
      children: [
        {
          name: 'login',
          path: 'login',
          component: lazyLoading('auth/login/NewLogin'),
          props: true
        },
        {
          name: 'auth2FA',
          path: '2fa',
          component: lazyLoading('auth/2fa/index'),
          props: false,
          meta: {
            preventBack: true
          }
        },
      ],
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        // {
        //   name: 'login',
        //   path: 'login',
        //   // component: () => import('../components/auth/login/Login.vue'),
        //   component: lazyLoading('auth/login/Login'),
        //   props: true,
        // },
        {
          name: 'signup',
          path: 'signup',
          // component: () => import('../components/auth/signup/Signup.vue'),
          component: lazyLoading('auth/signup/Signup'),
        },
        {
          name: 'logout',
          path: 'logout',
          // component: () => import('../components/auth/logout/Logout.vue'),
          component: lazyLoading('auth/logout/Logout'),
        },
        {
          name: 'recover',
          path: 'recover',
          // component: () => import('../components/auth/reset/RecoverPassword.vue'),
          component: lazyLoading('auth/reset/RecoverPassword'),
        },
        {
          name: 'resetpassword',
          path: ':id/resetpassword/:token',
          // component: () => import('../components/auth/reset/ResetPassword.vue'),
          component: lazyLoading('auth/reset/ResetPassword'),
        },
        {
          name: 'consent',
          path: 'consent/approved',
          component: lazyLoading('auth/consent/Approved'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    {
      path: '/account',
      component: AuthLayout,
      children: [
        {
          name: 'confirmed',
          path: 'confirmed',
          component: lazyLoading('account/Confirmed'),
        },
      ],
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'profile',
          path: 'profile',
          component: lazyLoading('profile/index'),
          meta: {
            auth: true,
          },
          default: true,
        },
      ],
    },
    {
      name: 'Consent',
      path: '/consent/approved',
      component: lazyLoading('consent/index'),
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'support_hub',
          path: 'support-hub',
          component: lazyLoading('support_hub/index'),
          meta: {
            auth: true,
          },
          default: true,
        },
      ],
    },
  ],
})
const router = createRouter()

router.resetRouter = () => {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
